import { Component, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { TranslationService } from "../../../translate.service";
import { ClevertapService } from "../../../service/clevertap.service";
import { LeadService } from "../../../service/lead.service";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-mobile-success-page",
  imports: [TranslatePipe, CommonModule],
  templateUrl: "./mobile-success-page.component.html",
  styleUrl: "./mobile-success-page.component.scss",
})
export class MobileSuccessPageComponent {
  router = inject(Router);
  status: string = "";
  private _translationService = inject(TranslationService);
  translateService = inject(TranslateService);
  private clevertapService = inject(ClevertapService);
  leadService = inject(LeadService);
  userDetails: any;
  userMobileNo: any;
  isLoading: boolean = false;
  isLoadingExplore = false;
  data = {
    email: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    name: "",
    customerId: "",
    uuid: ""
  };
  countryCode: any;
  constructor(
    private route: ActivatedRoute,
    private _actRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this._actRoute.queryParams.subscribe((queryParams) => {
      const userId = queryParams["userId"];
      if (userId) {
        this.fetchUserDetails(userId, true);
      }
    });

    // Unified 1s delay for reliable campaign and prompt triggers
    setTimeout(() => {
      this.clevertapService.trackEvent('explored_after_submission', {
        product_type: 'income_protection'
      });
      this.clevertapService.showNotificationPrompt();
    }, 1000);

    this.route.url.subscribe((segments) => {
      const lastSegment = segments[segments.length - 1]?.path;
      this.status = lastSegment;
      if (this.status !== "mobile-success-page") {
        setTimeout(() => {
          if (window.webkit?.messageHandlers?.closeHandler) {
            window.webkit.messageHandlers.closeHandler.postMessage("cancel");
          } else if (window.AndroidInterface?.closeWebView) {
            window.AndroidInterface.closeWebView("cancel");
          } else {
            console.log(
              "Failed to close the WebView. No native interface found."
            );
          }
        }, 3000);
      }
    });
  }

  /** To fetch user details */
  private fetchUserDetails(userId: string, triggerCleverTap?: boolean) {
    this.leadService.getUserDetails(userId).subscribe({
      next: (response: any) => {
        if (response.success) {
          if (triggerCleverTap) {
            this.userDetails = response.data;
            const user = this.userDetails;
            const name = user.name || "";
            const firstName = name.split(" ")[0] || "";
            const lastName = name.split(" ").slice(1).join(" ") || "";
            const email = user.email || "";
            const phoneNumber = user.mobileNo || "";
            this.countryCode = user.countryCode || "84";
            const customerId = `${this.countryCode}-${phoneNumber}`;
            this.data.email = email;
            this.data.firstName = firstName;
            this.data.lastName = lastName;
            this.data.phoneNumber = phoneNumber;
            this.data.name = name;
            this.data.customerId = customerId;
            this.data.uuid = user.uuid || '';
          }
        }
      },
      error: (error) => {
        console.log(error);
      },
    });
  }
  async goToHome() {
    const countryCode = this.countryCode;
    const email = this.data.email;
    const queryParams = this.route.snapshot.queryParams;
    const pathSegments = window.location.pathname.split("/").filter(Boolean);
    const supportedLangs = ["en", "vi"];
    let lang;
    const langIndex = 0;
    if (supportedLangs.includes(pathSegments[langIndex])) {
      lang = pathSegments[langIndex];
    }
    const { ...otherParams } = queryParams;
    const queryString = new URLSearchParams(otherParams).toString();
    const homeUrl = queryString
      ? `${lang}/income-protection-insurance/?${queryString}`
      : `${lang}/income-protection-insurance`;
    this.clevertapService
      .setUserProfile(
        this.data.email,
        this.data.firstName,
        this.data.lastName,
        this.data.phoneNumber,
        this.data.name,
        this.data.uuid
      );
    this.clevertapService.trackEvent("clicked_back_home_after_submission", {
      product_type: "income_protection",
      mobileNo: this.data.phoneNumber,
      countryCode,
      customer_id: this.data.customerId,
      first_name: this.data.firstName,
      last_name: this.data.lastName,
      email,
    });
    this.isLoading = true;
    setTimeout(() => {
      if (window.webkit?.messageHandlers?.closeHandler) {
        window.webkit.messageHandlers.closeHandler.postMessage(homeUrl);
      } else if (window.AndroidInterface?.closeWebView) {
        try {
          window.AndroidInterface.closeWebView(homeUrl);
        } catch {
          window.location.href = homeUrl;
        }
      } else {
        window.location.href = homeUrl;
      }
      this.isLoading = false;
    }, 2000);
  }
  async goToExplore() {
    this.isLoadingExplore = true;
    const countryCode = this.countryCode;
    const email = this.data.email;
    this.clevertapService
      .setUserProfile(
        this.data.email,
        this.data.firstName,
        this.data.lastName,
        this.data.phoneNumber,
        this.data.name,
        this.data.uuid
      );
    this.clevertapService.trackEvent("explored_after_submission", {
      product_type: "income_protection",
      mobileNo: this.data.phoneNumber,
      countryCode,
      customer_id: this.data.customerId,
      first_name: this.data.firstName,
      last_name: this.data.lastName,
      email,
    });
    setTimeout(() => {

      if (window.webkit?.messageHandlers?.closeHandler) {
        window.webkit.messageHandlers.closeHandler.postMessage("explore");
      } else if (window.AndroidInterface?.closeWebView) {
        window.AndroidInterface.closeWebView("explore");
        this.isLoadingExplore = false;
      } else {
        console.log("Failed to close the WebView. No native interface found.");
      }
    }, 2000);

  }
}
